import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  isActive?: boolean;
}
export const ReportCentre: React.FC<Props> = ({ isActive }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);
  const fill = isActive ? 'url(#icon-gradient-rc)' : colors.cflowerBlue;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
      <path
        d="M15.6462 1.30385C15.6462 0.583752 15.0624 0 14.3423 0H1.30385C0.583752 0 0 0.583752 0 1.30385C0 2.02394 0.583752 2.60769 1.30385 2.60769H14.3423C15.0624 2.60769 15.6462 2.02394 15.6462 1.30385Z"
        fill={fill}
      />
      <path
        d="M15.6462 6.51924C15.6462 5.79914 15.0624 5.21539 14.3423 5.21539H1.30385C0.583752 5.21539 0 5.79914 0 6.51924C0 7.23933 0.583752 7.82308 1.30385 7.82308H14.3423C15.0624 7.82308 15.6462 7.23933 15.6462 6.51924Z"
        fill={fill}
      />
      <path
        d="M0 11.7346C0 11.0145 0.583752 10.4308 1.30385 10.4308H9.12693C9.84702 10.4308 10.4308 11.0145 10.4308 11.7346C10.4308 12.4547 9.84702 13.0385 9.12693 13.0385H1.30385C0.583752 13.0385 0 12.4547 0 11.7346Z"
        fill={fill}
      />
      <path
        d="M12.3679 12.4135C12.0115 12.0571 12.0115 11.4792 12.3679 11.1228L12.9213 10.5694C13.2777 10.213 13.8556 10.213 14.2121 10.5695L16.3323 12.6901L21.2187 7.80378C21.5752 7.44736 22.153 7.44736 22.5095 7.80379L23.0626 8.35696C23.4191 8.71338 23.4191 9.29127 23.0626 9.6477L16.9777 15.7327C16.6212 16.0891 16.0433 16.0891 15.6869 15.7327L12.3679 12.4135Z"
        fill={fill}
      />
      <defs>
        <linearGradient id="icon-gradient-rc" x1="11.665" y1="0" x2="11.665" y2="16" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
